import React from 'react';

import qs from 'qs';
import { FormattedMessage } from 'react-intl';

import { DropdownItem } from '@atlaskit/dropdown-menu';

import { publishUiEvent } from 'src/utils/analytics/publish';

import { messages } from '../components/header-actions/header-actions.i18n';

type ViewInVSCodeProps = {
  currentPullRequestHref: string;
};

type Params = {
  q: string;
  source: 'bitbucket';
};

export default function ViewInVSCode(props: ViewInVSCodeProps) {
  const params: Params = {
    q: props.currentPullRequestHref,
    source: 'bitbucket',
  };

  const href = `vscode://atlassian.atlascode/openPullRequest?${qs.stringify(
    params
  )}`;

  return (
    <DropdownItem
      href={href}
      onClick={() => {
        publishUiEvent({
          action: 'clicked',
          actionSubject: 'link',
          source: 'pullrequestHeaderActionsDropdownMenu',
          actionSubjectId: 'viewInVSCode',
        });
      }}
    >
      <FormattedMessage {...messages.viewInVSCodeAction} />
    </DropdownItem>
  );
}
